import { VisitDataDto } from '@ecdlink/core';
import { CmsVisitDataInput } from '@ecdlink/graphql';
import { v4 as uuidv4 } from 'uuid';

export interface RawVisitQuestion {
  question: string;
  answer: string;
}

export interface RawVisitSection {
  visitSection: string;
  questions: RawVisitQuestion[];
}

export interface RawVisit {
  visitName: string;
  sections: RawVisitSection[];
}

/**
 * Flattens the nested visit structure into an array of VisitDataDto objects.
 * One object per question.
 */
export const transformToVisitDataDtos = (
  raw: CmsVisitDataInput,
  defaultSynced = true,
  visitId: string
): VisitDataDto[] => {
  const result: VisitDataDto[] = [];

  for (const section of raw.sections ?? []) {
    const sectionHasQuestions = !!section?.questions?.length;

    if (!sectionHasQuestions && section?.visitSection) {
      result.push({
        id: uuidv4(),
        visitId: visitId,
        visitName: raw?.visitName || '',
        visitSection: section.visitSection,
        question: '',
        questionAnswer: '',
        synced: defaultSynced,
        insertedDate: new Date().toISOString(),
      });
      continue;
    }

    for (const q of section?.questions ?? []) {
      result.push({
        id: uuidv4(),
        visitId: visitId,
        visitName: raw?.visitName || '',
        visitSection: section?.visitSection || '',
        question: q?.question || '',
        questionAnswer: q?.answer || '',
        synced: defaultSynced,
        insertedDate: new Date().toISOString(),
      });
    }
  }

  return result;
};
